import { initializeApp } from "firebase/app";
import { getAnalytics, logEvent as firebaseLogEvent } from "firebase/analytics";
import { firebaseConfig } from "../../config/firebase";
import { currentNetwork } from "../../utils";

const config = firebaseConfig[currentNetwork];
const app = initializeApp(config);
export const analyticsInstance = getAnalytics(app);